import { Pipe, PipeTransform } from '@angular/core';
import { snakeCaseToCamelCase } from '../util/string-util';

@Pipe({
  name: 'snakeCaseToCamelCase'
})
export class SnakeCaseToCamelCasePipe implements PipeTransform {

  transform(value: string): string {
    if (value == null)
      return null;
    return snakeCaseToCamelCase(value);
  }
}
